import Api from "../axios";

export default async function getNoticeList(){
    return await Api.get('/notice_list')
}